module.exports = __webpack_public_path__ + "img/Cw-U_1-5x4_U1-2_60-DGU_f-Al_c-Al_Fv-Al(400).16ce8c55.png";